import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// The brand's colors and font, then global styles, so component CSS modules can override them.
import "@brand/theme.css";
import "./styles/global.css";
import { App } from "./App";
import { seedPrerenderedQueries } from "./prerenderData";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => count < 3 && !(err instanceof Error && "status" in err && err.status === 404),
    },
  },
});

seedPrerenderedQueries(queryClient);

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// A pre-rendered page has its HTML already; any other route starts empty (scripts/prerender.mjs).
const root = document.getElementById("root")!;
if (root.hasChildNodes()) ReactDOM.hydrateRoot(root, app);
else ReactDOM.createRoot(root).render(app);
